"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var ArrowBack_1 = __importDefault(require("@mui/icons-material/ArrowBack"));
var react_router_dom_1 = require("react-router-dom");
var trans_1 = __importDefault(require("@/plugins/trans"));
var SearchVacanciesContext_1 = __importDefault(require("../context/SearchVacanciesContext"));
var ApplyVacancyContext_1 = __importDefault(require("../context/ApplyVacancyContext"));
var useIsSmallScreen_1 = __importDefault(require("../hooks/useIsSmallScreen"));
var classes = {
    container: {
        color: 'white',
        backgroundColor: function (theme) { return theme.palette.secondary.main; },
        zIndex: 6,
        top: 0,
        position: 'sticky',
    },
};
var BackTopBar = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var providedQuery = (0, react_1.useContext)(SearchVacanciesContext_1.default).providedQuery;
    var _a = (0, react_1.useContext)(ApplyVacancyContext_1.default), openApplyVacancy = _a.openApplyVacancy, handleOpenApplyVacancy = _a.handleOpenApplyVacancy;
    var pathname = (0, react_router_dom_1.useLocation)().pathname;
    var isSmallScreen = (0, useIsSmallScreen_1.default)();
    var isBookmarkedPage = pathname.includes('saved-vacancies');
    var isPathChat = pathname.match(new RegExp('(connections/chats)/[0-9]'));
    var isPathRecruiter = pathname.match(new RegExp('(connections/recruiters)/[0-9]'));
    var isPathInvites = pathname.match(new RegExp('(connections/invites)/[0-9]'));
    var isPathApplications = pathname.match(new RegExp('(applications/(active|concept|completed))/[0-9]'));
    var handleNavigate = function () {
        var navigateUrl = "/vacancies?".concat(providedQuery);
        if (openApplyVacancy) {
            handleOpenApplyVacancy(false);
            return;
        }
        if (isBookmarkedPage) {
            navigateUrl = '/saved-vacancies';
        }
        if (isPathChat) {
            navigateUrl = '/connections/chats';
        }
        if (isPathRecruiter) {
            navigateUrl = '/connections/recruiters';
        }
        if (isPathInvites) {
            navigateUrl = '/connections/invites';
        }
        if (isPathApplications) {
            var statusParam = pathname.split('/')[2];
            navigateUrl = "/applications/".concat(statusParam);
        }
        navigate(navigateUrl);
    };
    var title = (0, react_1.useMemo)(function () {
        if (isPathChat) {
            return trans_1.default.get('labels.frontend.connections.back_to_chats');
        }
        if (isPathRecruiter) {
            return trans_1.default.get('labels.frontend.connections.back_to_recruiters');
        }
        if (isPathInvites) {
            return trans_1.default.get('labels.frontend.connections.back_to_invites');
        }
        if (isPathApplications) {
            return trans_1.default.get('labels.frontend.applications.back_to_applications');
        }
        return trans_1.default.get('labels.frontend.vacancy.back_to_vacancies');
    }, [isPathChat, isPathRecruiter, isPathInvites, isPathApplications]);
    return ((0, jsx_runtime_1.jsx)(material_1.Container, __assign({ sx: __assign(__assign({}, classes.container), { zIndex: isSmallScreen && openApplyVacancy ? 1450 : 6 }), maxWidth: "lg" }, { children: (0, jsx_runtime_1.jsxs)("nav", __assign({ role: "navigation", css: {
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                height: 50,
            } }, { children: [(0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ onClick: function () { return handleNavigate(); }, css: { width: 50 } }, { children: (0, jsx_runtime_1.jsx)(ArrowBack_1.default, { sx: { color: 'white' } }) })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h6", css: { fontSize: 16 } }, { children: title }))] })) })));
};
exports.default = BackTopBar;
